@if (view == 'add-task') {
  <app-add-task
    [module]="module"
    [position]="positionTask"
    [project]="selected.project"
    [phase]="selected.phase"
    [infoProjectPhases]="infoProjectPhases"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-task>
}

@if (view == 'edit-task') {
  <app-add-task
    [module]="module"
    [project]="selected.project"
    [phase]="selected.phase"
    [task]="selected.task"
    [infoProjectPhases]="infoProjectPhases"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-task>
}

@if (view == 'edit-phase') {
  <app-add-phase
    [project]="selected.project"
    [phase]="selected.phase"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-phase>
}

@if (view == 'add-break') {
  <app-add-break
    [project]="selected.project"
    [task]="selected.task"
    [chapter]="selected.chapter"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-break>
}

@if (view == 'change-quantity') {
  <app-add-quantity
    [project]="selected.project"
    [task]="selected.task"
    [chapter]="selected.chapter"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-quantity>
}

@if (view == 'change-duration') {
  <app-add-duration
    [project]="selected.project"
    [task]="selected.task"
    [chapter]="selected.chapter"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-duration>
}

@if (view == 'delete-task') {
  <app-delete-task
    [task]="selected.task"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-delete-task>
}

@if (view == 'add-timeline') {
  <app-add-timeline
    [project]="selected.project"
    [infoProjectPhases]="infoProjectPhases"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-timeline>
}

<div [ngClass]="{'main-wrapper': isMainPage}">
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    @if (isMainPage) {
      <div class="header">
        <div class="breadcrump">
          <ul>
            <li [routerLink]="['/home']">{{'Home' | translate}}</li>
            @if (currentProject) {
              <li [routerLink]="['/projects']">{{'Projects' | translate}}</li>
              <li [routerLink]="['/projects', currentProject.id]">{{currentProject.title}}</li>
              @if (module.name == 'post') {
                <li [routerLink]="['/projects', currentProject.id, 'post']">{{'Post-production'}}</li>
              }
            }
          </ul>
        </div>
        <div class="page-tittle">
          <h1>{{'Timeline' | translate}}</h1>
          <div class="buttons">
            <a (click)="goBack()">{{'Go back' | translate}}</a>
            <a (click)="goToHolidays()">{{'Holidays' | translate}}</a>
          </div>
        </div>
      </div>
    }
    @if (isMainPage) {
      <div class="row filter">
        <!-- <div class="XL-2 L-3 M-3 S-4 columns">
        <input type="text" class="search" placeholder="{{'Search' | translate}}" [(ngModel)]="search_text"
          name="search_text" (blur)="filter()">
      </div> -->
    </div>
  }
  @if (isMainPage) {
    <div>
      @if ((selected.task ||selected.phase || selected.project) && _gS.showContext && _gS.validateAcces({id:module.access, type:'write'})) {
        <div
          class="contextmenuConteiner" (click)="_gS.hidemenu()" (contextmenu)="_gS.hidemenu()">
          <div class="contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
            <ul>
              @switch (contextMenu) {
                @case ('project') {
                  <li [routerLink]="['/projects', $safeNavigationMigration(selected.project?.id)]">{{'View project' | translate}}</li>
                  <li (click)="changeView('add-timeline')">
                    {{(selected.project?.phases_project?.length ? 'Edit phases' : 'Add phases') | translate}}
                  </li>
                }
                @case ('phase') {
                  <li (click)="jumpToStart()">{{'Jump to start' | translate}}</li>
                  <li (click)="changeView('add-task'); changePositionTask(1)">{{'Add task' | translate}}</li>
                  <li (click)="changeView('edit-phase')">{{'Edit phase' | translate}}</li>
                }
                @case ('task') {
                  <li (click)="jumpToStart()">{{'Jump to start' | translate}}</li>
                  <li (click)="changeView('add-task'); changePositionTask(1)">{{'Add task' | translate}}</li>
                  <li (click)="changeView('edit-task')">{{'Edit task' | translate}}</li>
                  <li (click)="changeView('delete-task')">{{'Delete task' | translate}}</li>
                }
                @case ('task-simple') {
                  <li (click)="changeView('edit-task')">{{'Edit task' | translate}}</li>
                  <li (click)="changeView('add-break')">{{ (selected?.task?.break ? 'Edit break' : 'Add break') | translate}}</li>
                }
                @case ('chapter') {
                  <li (click)="changeView('add-break')">{{ (selected?.chapter?.break ? 'Edit break' : 'Add break') | translate}}</li>
                  <li (click)="changeView('change-duration')">{{'Change duration' | translate}}</li>
                  <li (click)="changeView('change-quantity')">{{'Change quantity' | translate}}</li>
                  <li (click)="changeView('edit-task')">{{'Edit task' | translate}}</li>
                }
              }
            </ul>
          </div>
        </div>
      }
    </div>
  }
  <div #timelineWrapper [ngClass]="{'standalone': !isMainPage}" [ngStyle]="{'max-height.px': maxHeight}" class="wrapper-content timeline-wrapper">
    <!-- Left panel -->
    <div class="projects">
      <div [ngClass]="{ 'projects-gap-new': !isMainPage }">
        <div class="projects-gap" [ngClass]="typeTable">
          @if (isMainPage) {
            <div class="L-4 M-4 S-12 columns">
              <input type="date" name="date_timeline" [(ngModel)]="dateTimeline" (blur)="setNewDate()">
            </div>
          }
          @if (!isMainPage) {
            <div class="L-12 M-12 S-12 columns">
              <span>
                {{ 'Timeline' | translate | uppercase }}
              </span>
            </div>
          }
          @if (isMainPage) {
            <div class="L-8 M-8 S-12 columns buttons-wrapper">
              <div class="line-buttons">
                <a class="line_button" (click)="changeTableDuration(TIMELINE_DURATION.TwoYears)" [ngClass]="{'active': timelineDuration == TIMELINE_DURATION.TwoYears}">{{'24M' | translate}}</a>
                <a class="line_button" (click)="changeTableDuration(TIMELINE_DURATION.Year)" [ngClass]="{'active': timelineDuration == TIMELINE_DURATION.Year}">{{'12M' | translate}}</a>
                <a class="line_button" (click)="changeTableDuration(TIMELINE_DURATION.HalfYear)" [ngClass]="{'active': timelineDuration == TIMELINE_DURATION.HalfYear}">{{'6M' | translate}}</a>
              </div>
              <div class="line-buttons">
                <a class="line_button" (click)="changeTableType(TYPE_TABLE.Monthly)" [ngClass]="{'active': typeTable == TYPE_TABLE.Monthly}">{{'Months' | translate}}</a>
                <a class="line_button" (click)="changeTableType(TYPE_TABLE.Weekly)" [ngClass]="{'active': typeTable == TYPE_TABLE.Weekly}">{{'Weeks' | translate}}</a>
                <a class="line_button" (click)="changeTableType(TYPE_TABLE.Daily)" [ngClass]="{'active': typeTable == TYPE_TABLE.Daily}">{{'Days' | translate}}</a>
              </div>
            </div>
          }
        </div>
      </div>
      @for (project of projects; track project) {
        <div class="project-card">
          <div class="project-name" (click)="toggleProject(project)" [ngStyle]="{'height.px': project.height}" (contextmenu)="onProjectContext($event, project)">
            @if (isMainPage) {
              <p [tooltip]="project.title" [placement]="'top'" [lengthToShow]="30">
                {{project.title | slice: 0: 30}}@if (project.title.length > 30) {
                <span>...</span>
              }
            </p>
          }
          @if (!isMainPage) {
            <div class="L-4 M-4 S-12 columns">
              <input type="date" name="date_timeline" [(ngModel)]="dateTimeline" (blur)="setNewDate()">
            </div>
          }
          @if (isMainPage) {
            <div class="info-chapters">
              <p>{{project.number_episodes}} {{'Chapters' | translate}}</p>
              <p>{{project.country ? project.country : '--'}}</p>
            </div>
          }
        </div>
        @if (project.isOpen) {
          @for (phase of project.phases_project; track phase; let i = $index) {
            <div class="project-item" (click)="togglePhase(phase)" (contextmenu)="onPhaseContext($event, project, phase)">
              <p>
                @if (module.name != 'post') {
                  <span class="material-icons arrow">{{phase.isOpen ? 'expand_less' : 'expand_more'}}</span>
                }
                <span class="circle"
                [ngStyle]="{'background-color': phase.color_code ? phase.color_code : 'white'}"></span>
                {{_gS.backTranslate(phase, 'phase', '--')}}
              </p>
              <div class="week-number">
                <span>{{phase.week ? phase.week+'W' : '--'}}</span>
                <span class="icon-info material-icons" (mouseover)="sonInfoHover($event)">info</span>
                <div class="info-item-hover">
                  <div class="contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
                    <p>{{'Date start' | translate}}: {{phase.date_start | date: 'MMMM d, y'}}</p>
                    <p>{{'Weeks' | translate}}: {{phase.week ? phase.week : '--'}}</p>
                  </div>
                </div>
              </div>
            </div>
            @if (phase.isOpen) {
              <div
                class="drop-wrapper wrapper-{{i}}"
                cdkDropList
                (cdkDropListDropped)="drop($event, phase)">
                @for (task of phase.tasks; track task) {
                  <div class="project-item child drop-item" cdkDrag cdkDragBoundary=".wrapper-{{i}}"
                    (contextmenu)="onTaskContext($event, project, phase, task)">
                    <div class="custom-placeholder" *cdkDragPlaceholder></div>
                    <p [tooltip]="task.task_name" [placement]="'top'" [lengthToShow]="25">
                      {{task.position}} - {{task.task_name | slice: 0: 25}}@if (task.task_name.length > 25) {
                      <span>...</span>
                    }
                  </p>
                  <div class="week-number">
                    @if (task.predecessor_position) {
                      <span>(PRE: {{task.predecessor_position}})</span>
                    }
                    <span class="icon-info material-icons" (mouseover)="sonInfoHover($event)">info</span>
                    <div class="info-item-hover">
                      <div class="contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
                        <p>{{'Task unit' | translate}}: {{task.task_unit_id ? _gS.backTranslate(task,'task_unit') : ''}}</p>
                        <p>{{'Duration' | translate}}: {{task.duration ? task.duration : ''}} {{ task.task_duration_type_id ? '('+_gS.backTranslate(task,'task_duration')+')' : ''}}</p>
                        @if (task.predecessor_id) {
                          <p>{{'Predecessor' | translate}}: {{task.predecessor_name}}</p>
                        }
                        @if (task.task_start_at_id) {
                          <p>{{'Start at' | translate}}: {{_gS.backTranslate(task,'task_start')}}</p>
                        }
                        @if (task.break_episode) {
                          <p>{{'Max chapters' | translate}}: {{task.break_episode}}</p>
                        }
                        @if (task.work_days) {
                          <p>{{'Weekly days' | translate}}: {{task.work_days}}</p>
                        }
                        @if (task.task_country.length) {
                          <p>{{'Countries' | translate}}: {{_gS.backTranslate(task,'countries_concat')}}</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }
      }
    </div>
  }
</div>
<!-- Timeline -->
<div [ngClass]="{ 'timeline': isMainPage, 'timeline-home': !isMainPage }">
  <app-timeline-table
    [isMainPage]="isMainPage"
    [type]="typeTable"
    [weeks]="header.weeks"
    [days]="header.days"
    [months]="header.months"
    [years]="header.years"
    [projects]="projects"
    [phasesProject]="phasesProject"
    (contextChapterTask)="onChapterTaskContext($event)"
    (contextTask)="onTaskTableContext($event)"
    (onPaginationTable)="paginateTable($event)">
  </app-timeline-table>
</div>
</div>
}
</div>
